import React, { useState, useEffect, useRef } from 'react';
import CubaNetworkMap from '../components/shared/CubaNetworkMap';

// ── Rates hook
const useRates = () => {
  const [rates, setRates] = useState({ eur: 750, usd: 645, usdt: 645 });
  useEffect(() => {
    const load = async () => {
      try {
        const r = await fetch('https://api.guarapo.app/api/v1/rates/');
        const d = await r.json();
        setRates({ eur: d.eur_cup || 750, usd: d.usd_cup || 645, usdt: d.usdt_cup || 645 });
      } catch {}
    };
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, []);
  return rates;
};

// ── Calculator (consume /api/v1/quote — cero cálculo de fees en JS)
const Calculator = () => {
  const [amount, setAmount] = useState('100');
  const [currency, setCurrency] = useState('USD');
  const [q, setQ] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const parsed = parseFloat(amount);
    if (!parsed || parsed <= 0) { setQ(null); return; }
    setLoading(true);
    const t = setTimeout(async () => {
      try {
        const r = await fetch(`https://api.guarapo.app/api/v1/quote/?amount=${parsed}&currency=${currency}`);
        if (!r.ok) throw new Error('quote');
        setQ(await r.json());
      } catch { setQ(null); }
      finally { setLoading(false); }
    }, 400);
    return () => clearTimeout(t);
  }, [amount, currency]);

  const dash = '—';
  const money = (v) => (v === undefined || v === null ? dash : `${v} ${currency}`);

  return (
    <div style={{ background: 'rgba(255,255,255,.04)', border: '1px solid rgba(255,255,255,.1)', borderRadius: 22, padding: 28, backdropFilter: 'blur(10px)' }}>
      <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: '.18em', textTransform: 'uppercase', color: '#4ade80', marginBottom: 18 }}>Calculadora en vivo</div>
      <div style={{ display: 'flex', gap: 8, marginBottom: 18 }}>
        <div style={{ flex: 1, position: 'relative' }}>
          <span style={{ position: 'absolute', left: 14, top: '50%', transform: 'translateY(-50%)', fontSize: 18, color: 'rgba(255,255,255,.3)', fontFamily: 'Georgia,serif' }}>{currency === 'EUR' ? '€' : currency === 'BRL' ? 'R$' : '$'}</span>
          <input type="number" value={amount} onChange={e => setAmount(e.target.value)}
            style={{ width: '100%', padding: '14px 14px 14px 36px', background: 'rgba(255,255,255,.07)', border: '1px solid rgba(255,255,255,.15)', borderRadius: 12, fontSize: 30, fontWeight: 800, color: '#fff', outline: 'none', boxSizing: 'border-box', fontFamily: 'Georgia,serif' }} />
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          {['USD', 'EUR', 'BRL'].map(c => (
            <button key={c} onClick={() => setCurrency(c)} style={{ padding: '9px 14px', borderRadius: 9, border: `1px solid ${currency === c ? '#4ade80' : 'rgba(255,255,255,.12)'}`, background: currency === c ? 'rgba(74,222,128,.12)' : 'transparent', color: currency === c ? '#4ade80' : 'rgba(255,255,255,.4)', fontSize: 13, fontWeight: 700, cursor: 'pointer', transition: 'all .15s' }}>{c}</button>
          ))}
        </div>
      </div>

      <div style={{ background: 'rgba(0,0,0,.25)', borderRadius: 12, padding: '14px 16px', marginBottom: 16, fontSize: 13, opacity: loading ? .55 : 1, transition: 'opacity .15s' }}>
        {[
          ['Tú pagas', money(q?.sender_pays), '#fff'],
          [`Fee Guarapo (${q?.sender_fee_pct || dash})`, q ? `-${q.sender_fee} ${currency}` : dash, 'rgba(255,255,255,.4)'],
          [`Costo de entrega (${q?.agent_fee_pct || dash})`, q ? `-${q.agent_fee} ${currency}` : dash, 'rgba(255,255,255,.4)'],
          ['Reserva disputas (0.5%)', q ? `-${q.reserve} ${currency}` : dash, 'rgba(255,255,255,.3)'],
          ['Agente entrega', money(q?.agent_receives), '#4ade80'],
        ].map(([k, v, c]) => (
          <div key={k} style={{ display: 'flex', justifyContent: 'space-between', padding: '5px 0', borderBottom: '1px solid rgba(255,255,255,.04)' }}>
            <span style={{ color: 'rgba(255,255,255,.45)' }}>{k}</span>
            <span style={{ color: c, fontWeight: 600 }}>{v}</span>
          </div>
        ))}
      </div>

      <div style={{ background: 'linear-gradient(135deg,rgba(74,222,128,.14),rgba(74,222,128,.04))', border: '1px solid rgba(74,222,128,.25)', borderRadius: 14, padding: '18px', textAlign: 'center', marginBottom: 16 }}>
        <div style={{ fontSize: 10, color: 'rgba(74,222,128,.6)', letterSpacing: '.14em', textTransform: 'uppercase', marginBottom: 6 }}>Tu familia recibe</div>
        <div style={{ fontFamily: 'Georgia,serif', fontSize: 46, fontWeight: 700, color: '#4ade80', letterSpacing: '-1px', lineHeight: 1 }}>
          {q ? q.cup_to_deliver.toLocaleString() : dash}
        </div>
        <div style={{ fontSize: 13, color: 'rgba(255,255,255,.35)', marginTop: 4 }}>
          CUP · Tasa hoy: 1 {currency} = {q ? q.rate : dash} CUP
        </div>
      </div>

      <a href="/registro" style={{ display: 'block', padding: '14px', borderRadius: 12, background: '#4ade80', color: '#0a0a0a', fontSize: 15, fontWeight: 800, textAlign: 'center', textDecoration: 'none', letterSpacing: '.01em' }}>
        Enviar ahora →
      </a>
    </div>
  );
};

// ── Cuba map
const CoverageMap = () => {
  const [hovered, setHovered] = useState(null);
  const provinces = [
    { name: 'Pinar del Río', x: 11, y: 42, active: true, agents: 3 },
    { name: 'Artemisa', x: 20, y: 45, active: true, agents: 2 },
    { name: 'La Habana', x: 27, y: 43, active: true, agents: 12 },
    { name: 'Mayabeque', x: 33, y: 50, active: true, agents: 2 },
    { name: 'Matanzas', x: 40, y: 47, active: true, agents: 6 },
    { name: 'Cienfuegos', x: 46, y: 53, active: true, agents: 3 },
    { name: 'Villa Clara', x: 52, y: 43, active: true, agents: 4 },
    { name: 'Sancti Spíritus', x: 58, y: 45, active: true, agents: 3 },
    { name: 'Ciego de Ávila', x: 64, y: 41, active: true, agents: 2 },
    { name: 'Camagüey', x: 72, y: 41, active: true, agents: 5 },
    { name: 'Las Tunas', x: 79, y: 37, active: false, agents: 0 },
    { name: 'Holguín', x: 84, y: 34, active: true, agents: 4 },
    { name: 'Granma', x: 80, y: 47, active: true, agents: 3 },
    { name: 'Santiago de Cuba', x: 88, y: 51, active: true, agents: 6 },
    { name: 'Guantánamo', x: 93, y: 53, active: false, agents: 0 },
  ];
  return (
    <div style={{ background: 'rgba(255,255,255,.03)', border: '1px solid rgba(255,255,255,.07)', borderRadius: 20, padding: 24, position: 'relative' }}>
      <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: '.14em', textTransform: 'uppercase', color: '#4ade80', marginBottom: 4 }}>Cobertura</div>
      <div style={{ fontSize: 13, color: 'rgba(255,255,255,.4)', marginBottom: 20 }}>{provinces.filter(p=>p.active).length} provincias · {provinces.reduce((s,p)=>s+p.agents,0)} agentes activos</div>
      <div style={{ position: 'relative', height: 180 }}>
        <svg viewBox="0 0 100 70" style={{ width: '100%', height: '100%' }}>
          <path d="M5,46 Q10,36 15,38 Q22,40 27,42 Q37,48 45,51 Q55,51 64,47 Q73,43 81,44 Q87,47 92,51 Q97,53 98,56 Q95,59 88,57 Q80,55 73,53 Q63,51 53,53 Q43,55 33,53 Q23,53 16,51 Q10,50 7,48 Z" fill="rgba(74,222,128,.07)" stroke="rgba(74,222,128,.18)" strokeWidth="0.5"/>
          {provinces.map((p,i) => (
            <g key={i} onMouseEnter={()=>setHovered(p)} onMouseLeave={()=>setHovered(null)} style={{cursor:'pointer'}}>
              {p.active && <circle cx={p.x} cy={p.y} r={5} fill="rgba(74,222,128,.1)"/>}
              <circle cx={p.x} cy={p.y} r={p.active?2.5:1.5} fill={p.active?'#4ade80':'rgba(255,255,255,.2)'}/>
            </g>
          ))}
        </svg>
        {hovered && (
          <div style={{ position: 'absolute', top: 0, left: '50%', transform: 'translateX(-50%)', background: '#111', border: '1px solid rgba(74,222,128,.3)', borderRadius: 8, padding: '5px 12px', fontSize: 12, color: '#fff', whiteSpace: 'nowrap', pointerEvents: 'none' }}>
            <b>{hovered.name}</b> · {hovered.active ? `${hovered.agents} agentes` : 'Próximamente'}
          </div>
        )}
      </div>
      <div style={{ display: 'flex', gap: 16, marginTop: 8 }}>
        {[['#4ade80','Activa'],['rgba(255,255,255,.2)','Próximamente']].map(([c,l]) => (
          <div key={l} style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 11, color: 'rgba(255,255,255,.45)' }}>
            <div style={{ width: 8, height: 8, borderRadius: '50%', background: c }}/>{l}
          </div>
        ))}
      </div>
    </div>
  );
};

// ── Main
export default function Landing() {
  const rates = useRates();
  const [tickerX, setTickerX] = useState(0);
  const rafRef = useRef(null);
  const items = [`1 EUR → ${rates.eur} CUP`, `1 USD → ${rates.usd} CUP`, `1 USDT → ${rates.usdt} CUP`, `Escrow garantizado`, `Fee desde 2.5%`, `AI anti-fraude`, `PIN + foto en entrega`, `Agentes KYC verificados`, `Capablanca Digital OÜ · Estonia`];

  useEffect(() => {
    let x = 0;
    const tick = () => { x -= 0.4; if (x < -1100) x = 0; setTickerX(x); rafRef.current = requestAnimationFrame(tick); };
    rafRef.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(rafRef.current);
  }, [rates]);

  return (
    <div style={{ minHeight: '100vh', background: '#080808', color: '#fff', fontFamily: "'DM Sans','Outfit',sans-serif", overflowX: 'hidden' }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;700;800&display=swap');
        *{box-sizing:border-box;margin:0;padding:0}
        @keyframes pulse{0%,100%{opacity:1;transform:scale(1)}50%{opacity:.35;transform:scale(1.4)}}
        @keyframes fadeUp{from{opacity:0;transform:translateY(22px)}to{opacity:1;transform:translateY(0)}}
        @keyframes float{0%,100%{transform:translateY(0)}50%{transform:translateY(-12px)}}
        .fu{animation:fadeUp .65s cubic-bezier(.16,1,.3,1) both}
        .d1{animation-delay:.05s}.d2{animation-delay:.15s}.d3{animation-delay:.28s}.d4{animation-delay:.4s}
        .fl{animation:float 5s ease-in-out infinite}
        .cta:hover{transform:translateY(-2px);box-shadow:0 12px 36px rgba(74,222,128,.3)}
        .cta{transition:all .18s}
        .card{transition:all .28s}.card:hover{transform:translateY(-5px);border-color:rgba(74,222,128,.22)!important}
        input::-webkit-outer-spin-button,input::-webkit-inner-spin-button{-webkit-appearance:none}
        @media(max-width:860px){.hg{grid-template-columns:1fr!important}.steps{grid-template-columns:1fr!important}.testi{grid-template-columns:1fr!important}.cov{grid-template-columns:1fr!important}.trust{grid-template-columns:1fr 1fr!important}}
      `}</style>

      {/* NAV */}
      <nav style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100, height: 60, padding: '0 32px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: 'rgba(8,8,8,.88)', backdropFilter: 'blur(16px)', borderBottom: '1px solid rgba(255,255,255,.06)' }}>
        <div style={{ fontFamily: 'Georgia,serif', fontSize: 22, letterSpacing: '-.5px' }}>Guara<span style={{ color: '#4ade80' }}>po</span></div>
        <div style={{ display: 'flex', gap: 8 }}>
          <a href="/login" style={{ padding: '8px 16px', borderRadius: 9, border: '1px solid rgba(255,255,255,.11)', color: 'rgba(255,255,255,.7)', textDecoration: 'none', fontSize: 13, fontWeight: 600 }}>Iniciar sesión</a>
          <a href="/registro" style={{ padding: '8px 18px', borderRadius: 9, background: '#4ade80', color: '#080808', textDecoration: 'none', fontSize: 13, fontWeight: 800 }} className="cta">Registrarse</a>
        </div>
      </nav>

      {/* TICKER */}
      <div style={{ position: 'fixed', top: 60, left: 0, right: 0, zIndex: 99, height: 30, background: 'rgba(74,222,128,.06)', borderBottom: '1px solid rgba(74,222,128,.1)', overflow: 'hidden', display: 'flex', alignItems: 'center' }}>
        <div style={{ display: 'flex', gap: 52, whiteSpace: 'nowrap', transform: `translateX(${tickerX}px)` }}>
          {[...items,...items,...items,...items].map((item,i) => (
            <span key={i} style={{ fontSize: 11, color: '#4ade80', fontWeight: 600, letterSpacing: '.06em' }}>· {item}</span>
          ))}
        </div>
      </div>

      {/* HERO */}
      <section style={{ padding: '136px 32px 80px', maxWidth: 1180, margin: '0 auto', position: 'relative' }}>
        <div style={{ position: 'absolute', width: 800, height: 800, borderRadius: '50%', background: 'radial-gradient(circle,rgba(74,222,128,.09) 0%,transparent 68%)', top: -150, right: -250, pointerEvents: 'none' }} />
        <div className="hg" style={{ display: 'grid', gridTemplateColumns: '1fr 430px', gap: 64, alignItems: 'center' }}>
          <div>
            {/* Live badge */}
            <div className="fu d1" style={{ display: 'inline-flex', alignItems: 'center', gap: 8, padding: '6px 14px', background: 'rgba(74,222,128,.09)', border: '1px solid rgba(74,222,128,.18)', borderRadius: 30, marginBottom: 28 }}>
              <div style={{ width: 7, height: 7, borderRadius: '50%', background: '#4ade80', animation: 'pulse 2s infinite' }}/>
              <span style={{ fontSize: 12, color: '#4ade80', fontWeight: 600 }}>7 agentes disponibles ahora mismo en Cuba</span>
            </div>

            <h1 className="fu d2" style={{ fontFamily: 'Georgia,serif', fontSize: 'clamp(42px,5.2vw,74px)', lineHeight: 1.06, letterSpacing: '-2.5px', marginBottom: 22 }}>
              Envía dinero a Cuba.<br /><span style={{ color: '#4ade80' }}>Con garantía real.</span>
            </h1>

            <p className="fu d3" style={{ fontSize: 17, color: 'rgba(255,255,255,.5)', lineHeight: 1.78, marginBottom: 34, maxWidth: 490 }}>
              Mercado P2P con escrow inteligente. Tu dinero queda retenido hasta que un agente verificado entrega en mano — con foto y código PIN. La AI lo confirma. Tú cobras la garantía.
            </p>

            {/* Trust pills */}
            <div className="fu d4" style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 44 }}>
              {[['🔒','Escrow P2P'],['📍','PIN + foto en entrega'],['🤖','Verificación AI'],['🪪','KYC obligatorio'],['🏛️','Capablanca Digital OÜ']].map(([icon,text]) => (
                <div key={text} style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '5px 12px', background: 'rgba(255,255,255,.04)', border: '1px solid rgba(255,255,255,.08)', borderRadius: 30 }}>
                  <span style={{ fontSize: 12 }}>{icon}</span>
                  <span style={{ fontSize: 12, color: 'rgba(255,255,255,.5)', fontWeight: 500 }}>{text}</span>
                </div>
              ))}
            </div>

            {/* Stats */}
            <div className="fu d4" style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 20 }}>
              {[[String(rates.usd),'CUP/USD','Tasa hoy'],['7%','bruto','Fee total'],['48h','máx','Entrega']].map(([v,u,l]) => (
                <div key={l} style={{ borderTop: '2px solid rgba(74,222,128,.22)', paddingTop: 12 }}>
                  <div style={{ fontFamily: 'Georgia,serif', fontSize: 28, fontWeight: 700, lineHeight: 1 }}>{v}<span style={{ fontSize: 12, color: 'rgba(255,255,255,.3)', marginLeft: 3 }}>{u}</span></div>
                  <div style={{ fontSize: 12, color: 'rgba(255,255,255,.38)', marginTop: 4 }}>{l}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Calc */}
          <div className="fl fu d3"><Calculator /></div>
        </div>
      </section>

      {/* CÓMO FUNCIONA */}
      <section style={{ padding: '80px 32px', maxWidth: 1180, margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: 52 }}>
          <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: '.16em', textTransform: 'uppercase', color: '#4ade80', marginBottom: 12 }}>PROCESO P2P</div>
          <h2 style={{ fontFamily: 'Georgia,serif', fontSize: 'clamp(30px,3.8vw,50px)', letterSpacing: '-1.5px' }}>Cómo funciona el escrow</h2>
        </div>
        <div className="steps" style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 18 }}>
          {[
            { n:'01', icon:'💸', title:'Sender deposita', desc:'Pagas con USDT, Bitcoin, Zelle o Pix. Los fondos quedan en escrow — nadie los toca hasta la entrega.', tag:'Fondos bloqueados' },
            { n:'02', icon:'🤝', title:'Agente toma la orden', desc:'Un agente verificado en Cuba acepta tu orden del mercado P2P. Tú ves quién es, su rating y su historial de entregas.', tag:'Mercado P2P transparente' },
            { n:'03', icon:'📍', title:'Entrega con PIN + foto', desc:'El agente entrega en mano. El receptor muestra el PIN secreto. El agente sube la foto. La AI verifica y libera el pago automáticamente.', tag:'Verificación AI instantánea' },
          ].map((s,i) => (
            <div key={i} className="card" style={{ background: 'rgba(255,255,255,.03)', border: '1px solid rgba(255,255,255,.07)', borderRadius: 20, padding: 28, position: 'relative', overflow: 'hidden' }}>
              <div style={{ position: 'absolute', top: 14, right: 18, fontFamily: 'Georgia,serif', fontSize: 68, fontWeight: 700, color: 'rgba(255,255,255,.03)', lineHeight: 1 }}>{s.n}</div>
              <div style={{ fontSize: 36, marginBottom: 18 }}>{s.icon}</div>
              <h3 style={{ fontFamily: 'Georgia,serif', fontSize: 21, marginBottom: 10, letterSpacing: '-.4px' }}>{s.title}</h3>
              <p style={{ fontSize: 14, color: 'rgba(255,255,255,.48)', lineHeight: 1.75, marginBottom: 18 }}>{s.desc}</p>
              <div style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '4px 10px', background: 'rgba(74,222,128,.08)', border: '1px solid rgba(74,222,128,.16)', borderRadius: 20, fontSize: 11, color: '#4ade80', fontWeight: 600 }}>✓ {s.tag}</div>
            </div>
          ))}
        </div>

        {/* Escrow flow diagram */}
        <div style={{ marginTop: 32, background: 'rgba(255,255,255,.02)', border: '1px solid rgba(255,255,255,.07)', borderRadius: 16, padding: '24px 28px' }}>
          <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: '.14em', textTransform: 'uppercase', color: 'rgba(255,255,255,.3)', marginBottom: 18 }}>FLUJO DE FONDOS</div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap', justifyContent: 'center' }}>
            {[
              { label: 'Sender paga', sub: '$103.50 USD', color: '#fff' },
              { arrow: true },
              { label: 'Escrow Guarapo', sub: 'Fondos retenidos', color: '#4ade80', highlight: true },
              { arrow: true },
              { label: 'AI verifica entrega', sub: 'PIN + foto', color: '#fff' },
              { arrow: true },
              { label: 'Agente cobra', sub: '$96.50 USD', color: '#4ade80' },
              { plus: true },
              { label: 'Fondo reserva', sub: '0.5% por TX', color: 'rgba(255,255,255,.4)' },
            ].map((item, i) => {
              if (item.arrow) return <div key={i} style={{ color: 'rgba(255,255,255,.2)', fontSize: 18 }}>→</div>;
              if (item.plus) return <div key={i} style={{ color: 'rgba(255,255,255,.2)', fontSize: 16 }}>+</div>;
              return (
                <div key={i} style={{ textAlign: 'center', padding: '10px 16px', borderRadius: 10, background: item.highlight ? 'rgba(74,222,128,.1)' : 'rgba(255,255,255,.04)', border: `1px solid ${item.highlight ? 'rgba(74,222,128,.25)' : 'rgba(255,255,255,.06)'}` }}>
                  <div style={{ fontSize: 13, fontWeight: 700, color: item.color }}>{item.label}</div>
                  <div style={{ fontSize: 11, color: 'rgba(255,255,255,.35)', marginTop: 2 }}>{item.sub}</div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* AGENTES EN VIVO */}
      <section style={{ padding: '80px 32px', maxWidth: 1180, margin: '0 auto' }}>
        <div style={{ background: 'rgba(255,255,255,.02)', border: '1px solid rgba(255,255,255,.07)', borderRadius: 22, padding: '36px 36px 28px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 28, flexWrap: 'wrap', gap: 14 }}>
            <div>
              <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: '.16em', textTransform: 'uppercase', color: '#4ade80', marginBottom: 8 }}>MERCADO P2P</div>
              <h2 style={{ fontFamily: 'Georgia,serif', fontSize: 26, letterSpacing: '-.6px' }}>Agentes disponibles ahora</h2>
            </div>
            <a href="/agentes" style={{ padding: '9px 18px', borderRadius: 9, border: '1px solid rgba(74,222,128,.25)', color: '#4ade80', textDecoration: 'none', fontSize: 13, fontWeight: 600 }}>Ver todos →</a>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(230px,1fr))', gap: 14 }}>
            {[
              { name:'Carlos R.', zone:'Centro Habana', methods:['Efectivo','Transfermóvil'], rating:4.9, deliveries:87, online:true },
              { name:'Marta L.', zone:'Vedado, La Habana', methods:['Efectivo'], rating:5.0, deliveries:43, online:true },
              { name:'Jorge M.', zone:'Santiago Centro', methods:['Efectivo','Cubacel'], rating:4.8, deliveries:124, online:true },
              { name:'Ana P.', zone:'Camagüey', methods:['Efectivo','Transfermóvil'], rating:4.7, deliveries:61, online:false },
            ].map((a,i) => (
              <div key={i} style={{ background: 'rgba(255,255,255,.04)', border: `1px solid ${a.online?'rgba(74,222,128,.18)':'rgba(255,255,255,.06)'}`, borderRadius: 14, padding: 18 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
                  <div style={{ position: 'relative' }}>
                    <div style={{ width: 38, height: 38, borderRadius: '50%', background: 'linear-gradient(135deg,#4ade80,#22c55e)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 15, fontWeight: 800, color: '#080808' }}>{a.name.charAt(0)}</div>
                    <div style={{ position: 'absolute', bottom: -1, right: -1, width: 11, height: 11, borderRadius: '50%', background: a.online?'#4ade80':'#444', border: '2px solid #080808' }}/>
                  </div>
                  <div>
                    <div style={{ fontSize: 13, fontWeight: 700 }}>{a.name}</div>
                    <div style={{ fontSize: 11, color: 'rgba(255,255,255,.38)' }}>{a.zone}</div>
                  </div>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10, padding: '8px 0', borderTop: '1px solid rgba(255,255,255,.05)', borderBottom: '1px solid rgba(255,255,255,.05)' }}>
                  <div style={{ textAlign: 'center' }}>
                    <div style={{ color: '#f59e0b', fontSize: 11 }}>{'★'.repeat(Math.round(a.rating))}</div>
                    <div style={{ fontSize: 10, color: 'rgba(255,255,255,.35)', marginTop: 1 }}>{a.rating}</div>
                  </div>
                  <div style={{ textAlign: 'center' }}>
                    <div style={{ fontSize: 17, fontWeight: 800, color: '#4ade80' }}>{a.deliveries}</div>
                    <div style={{ fontSize: 10, color: 'rgba(255,255,255,.35)' }}>entregas</div>
                  </div>
                </div>
                <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
                  {a.methods.map(m => <span key={m} style={{ padding: '2px 7px', borderRadius: 20, background: 'rgba(255,255,255,.05)', fontSize: 10, color: 'rgba(255,255,255,.45)', fontWeight: 500 }}>{m}</span>)}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* COBERTURA */}
      <section style={{ padding: '80px 32px', maxWidth: 1180, margin: '0 auto' }}>
        <CubaNetworkMap />
      </section>

      {/* TESTIMONIOS */}
      <section style={{ padding: '80px 32px', maxWidth: 1180, margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: 48 }}>
          <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: '.16em', textTransform: 'uppercase', color: '#4ade80', marginBottom: 12 }}>TESTIMONIOS</div>
          <h2 style={{ fontFamily: 'Georgia,serif', fontSize: 'clamp(28px,3.4vw,44px)', letterSpacing: '-1px' }}>Lo que dicen nuestros usuarios</h2>
        </div>
        <div className="testi" style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 18 }}>
          {[
            { name:'Carlos M.', loc:'Miami, FL', text:'Con Guarapo mi mamá recibió el dinero en 6 horas y me mandaron foto. El escrow me dio total tranquilidad.', stars:5 },
            { name:'Laia R.', loc:'Barcelona, España', text:'El sistema de PIN fue genial. Sabía exactamente cuándo llegó el agente y cuándo se hizo la entrega. Increíble transparencia.', stars:5 },
            { name:'Marco V.', loc:'Roma, Italia', text:'Mi esposa es cubana. Hasta ahora era un caos enviar dinero. Guarapo lo cambió todo — rápido, seguro y sin sorpresas.', stars:5 },
          ].map((t,i) => (
            <div key={i} style={{ background: 'rgba(255,255,255,.03)', border: '1px solid rgba(255,255,255,.07)', borderRadius: 18, padding: 24 }}>
              <div style={{ color: '#f59e0b', fontSize: 14, marginBottom: 14 }}>{'★'.repeat(t.stars)}</div>
              <p style={{ fontSize: 14, color: 'rgba(255,255,255,.6)', lineHeight: 1.78, marginBottom: 18, fontStyle: 'italic' }}>"{t.text}"</p>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <div style={{ width: 36, height: 36, borderRadius: '50%', background: 'linear-gradient(135deg,#4ade80,#22c55e)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, fontWeight: 800, color: '#080808' }}>{t.name.charAt(0)}</div>
                <div>
                  <div style={{ fontSize: 13, fontWeight: 700 }}>{t.name}</div>
                  <div style={{ fontSize: 11, color: 'rgba(255,255,255,.32)' }}>{t.loc}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* TRUST */}
      <section style={{ padding: '56px 32px', borderTop: '1px solid rgba(255,255,255,.05)', borderBottom: '1px solid rgba(255,255,255,.05)', maxWidth: 1180, margin: '0 auto' }}>
        <div className="trust" style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 26 }}>
          {[
            { icon:'🏛️', title:'Empresa registrada', desc:'Capablanca Digital OÜ · Estonia · EU regulated · Reg. 16601596' },
            { icon:'🔒', title:'Escrow P2P', desc:'Fondos retenidos en custodia hasta confirmación con PIN + foto de entrega' },
            { icon:'🤖', title:'AI Anti-fraude', desc:'Claude Vision analiza cada foto de entrega. Score >85% = pago automático' },
            { icon:'🪪', title:'KYC obligatorio', desc:'Senders y agentes verificados con documento de identidad antes de operar' },
          ].map((t,i) => (
            <div key={i} style={{ display: 'flex', gap: 14 }}>
              <span style={{ fontSize: 24, flexShrink: 0, marginTop: 2 }}>{t.icon}</span>
              <div>
                <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 5 }}>{t.title}</div>
                <div style={{ fontSize: 12, color: 'rgba(255,255,255,.38)', lineHeight: 1.6 }}>{t.desc}</div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* CTA FINAL */}
      <section style={{ padding: '100px 32px', textAlign: 'center' }}>
        <div style={{ maxWidth: 540, margin: '0 auto' }}>
          <h2 style={{ fontFamily: 'Georgia,serif', fontSize: 'clamp(34px,4.2vw,58px)', letterSpacing: '-2px', lineHeight: 1.08, marginBottom: 20 }}>
            Tu familia te está<br /><span style={{ color: '#4ade80' }}>esperando.</span>
          </h2>
          <p style={{ fontSize: 16, color: 'rgba(255,255,255,.4)', marginBottom: 38, lineHeight: 1.72 }}>
            Únete al primer mercado P2P de remesas a Cuba con escrow garantizado y verificación por inteligencia artificial.
          </p>
          <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
            <a href="/registro" style={{ padding: '16px 34px', borderRadius: 12, background: '#4ade80', color: '#080808', fontSize: 15, fontWeight: 800, textDecoration: 'none' }} className="cta">Crear cuenta gratis →</a>
            <a href="/agente" style={{ padding: '16px 28px', borderRadius: 12, border: '1px solid rgba(255,255,255,.1)', color: 'rgba(255,255,255,.6)', fontSize: 15, fontWeight: 600, textDecoration: 'none' }}>Ser agente</a>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer style={{ borderTop: '1px solid rgba(255,255,255,.05)', padding: '26px 32px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12 }}>
        <div style={{ fontFamily: 'Georgia,serif', fontSize: 18 }}>Guara<span style={{ color: '#4ade80' }}>po</span></div>
        <div style={{ fontSize: 12, color: 'rgba(255,255,255,.22)' }}>© 2025 Capablanca Digital OÜ · Estonia · Todos los derechos reservados</div>
        <div style={{ display: 'flex', gap: 20 }}>
          {['Términos','Privacidad','Soporte'].map(l => (
            <a key={l} href="#" style={{ fontSize: 12, color: 'rgba(255,255,255,.28)', textDecoration: 'none' }}>{l}</a>
          ))}
        </div>
      </footer>
    </div>
  );
}
